import React from 'react';
import { Card, Row, Col, Statistic } from 'antd';
import type { ChainStats } from '../../../services/devApi';

interface Props {
  stats: ChainStats | null;
  loading: boolean;
}

const ChainStatsCards: React.FC<Props> = ({ stats, loading }) => {
  if (!stats) return null;

  const items = [
    { label: 'LIVE', value: stats.liveVerified, color: '#52c41a' },
    { label: 'INTEGRATION', value: stats.integrationVerified, color: '#1677ff' },
    { label: 'PARTIAL', value: stats.partiallyConnected, color: '#faad14' },
    { label: '有模組但斷鏈', value: stats.modulesExist, color: '#ff7a45' },
    { label: '未開始', value: stats.notStarted, color: '#8c8c8c' },
  ];

  return (
    <Row gutter={[16, 16]}>
      <Col span={4}>
        <Card size="small" loading={loading}>
          <Statistic title="總鏈條數" value={stats.total} />
        </Card>
      </Col>
      {items.map((item) => (
        <Col span={4} key={item.label}>
          <Card size="small" loading={loading}>
            <Statistic title={item.label} value={item.value} valueStyle={{ color: item.color }} />
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default ChainStatsCards;
